// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.dto.HpAuthFlow

export enum HpAuthFlow {
  DEFAULT = 'default',
  OTP = 'otp',
  SSO = 'sso',
}

export const HpAuthFlow_values = [HpAuthFlow.DEFAULT, HpAuthFlow.OTP, HpAuthFlow.SSO] as const;
